let env = "development";
const IsHttps = window.location.protocol === "https:";
if (typeof process !== "undefined") {
  env =
    process.env.REACT_APP_ENV === "test"
      ? "test"
      : process.env.REACT_APP_ENV === "production"
        ? "production"
        : "development";
}
const fimsUrl = {
  development: "https://fims-t.vsigo.cn/",
  test: "https://fims-t.vsigo.cn/",
  production: "https://fims.vsigo.cn/",
}[env];
const scsWebUrl = {
  development: "http://localhost:3000/",
  test: "https://scs-t.vsigo.cn/",
  production: "https://scs.vsigo.cn/",
}[env];

const eurekaUrlDic = {
  development: "https://escm-t.vsigo.cn/account",
  test: "https://escm-t.vsigo.cn/account",
  production: "https://escm.vsigo.cn/account",
}[env];

// SCS 账号权限服务
const scsAccountProviderUrl = {
  development: "https://escm-t.vsigo.cn/",
  test: "https://escm-t.vsigo.cn/",
  production: "https://escm.vsigo.cn/",
}[env];

const SapUrl = {
  development: "http://sap-t.vsigo.cn/scs/",
  test: "http://sap-t.vsigo.cn/scs/",
  production: "https://sap.vsigo.cn/scs/",
}[env];

const scpUrl = {
  development: "http://sap-t.vsigo.cn/",
  test: "http://sap-t.vsigo.cn/",
  production: "https://sap.vsigo.cn/",
}[env];

const EureUrl = {
  development: "http://eureka-t.vsigo.cn/",
  test: "http://eureka-t.vsigo.cn/",
  production: "http://eureka.vsigo.cn/",
}[env];

const oldScs = {
  development: "http://scsapi-t.vsigo.cn",
  test: "http://scsapi-t.vsigo.cn",
  production: "https://scsapi.vsigo.cn",
}[env];

const imageUrl = {
  development: "https://images-t.vsigo.cn/",
  test: "https://images-t.vsigo.cn/",
  production: "https://images.vsigo.cn/",
}[env];

const fileUrl = {
  development: "https://static-t.njtuling.com/",
  test: "https://static-t.njtuling.com/",
  production: "https://static.njtuling.com/",
}[env];

const erpapiUrl = {
  development: "http://erpapi.vsigo.cn/",
  test: "http://erpapi.vsigo.cn/",
  production: "http://erpapi.vsigo.cn/",
}[env];

const wmsApiUrl = {
  development: "http://wms-api-t.vsigo.cn/",
  test: "http://wms-api-t.vsigo.cn/",
  production: "http://wms-api.vsigo.cn/",
}[env];

const escmApiUrl = {
  development: "https://escm-api-t.vsigo.cn/api/",
  test: "https://escm-api-t.vsigo.cn/api/",
  production: "https://escm-api.vsigo.cn/api/",
}[env];

const escmProUrl = {
  development: "https://escm-api-t.vsigo.cn/pro/",
  test: "https://escm-api-t.vsigo.cn/pro/",
  production: "https://escm-api.vsigo.cn/pro/",
}[env];

const escmUrl = {
  development: "https://escm-api-t.vsigo.cn/",
  test: "https://escm-api-t.vsigo.cn/",
  production: "https://escm-api.vsigo.cn/",
}[env];

// SRM 供应商资质服务（原 erp-srm-sqm-service，已迁移至 sap 域名）
const sqmUrl = {
  development: "https://sap-t.vsigo.cn/srm-sqm/",
  test: "https://sap-t.vsigo.cn/srm-sqm/",
  production: "https://sap.vsigo.cn/srm-sqm/",
}[env];

const mdmUrl = {
  development: "https://erp-common-api-t.vsigo.cn/erp-master-data-management/",
  test: "https://erp-common-api-t.vsigo.cn/erp-master-data-management/",
  production: "http://erp-common-api.vsigo.cn/erp-master-data-management/",
}[env];
let commons = {
  escmUrl,
  sqmUrl,
  scsAccountProviderUrl,
  fimsUrl,
  scsWebUrl,
  env,
  escmApiUrl,
  oldScs,
  SapUrl,
  scpUrl,
  EureUrl,
  wmsApiUrl,
  erpapiUrl,
  eurekaUrlDic,
  imageUrl,
  fileUrl,
  escmProUrl,
  mdmUrl,
};
if (IsHttps) {
  let newcommons = {};
  for (let k in commons) {
    if (!commons[k]) {
      console.log(k);
    }
    newcommons[k] = commons[k] && commons[k].replace("http:", "https:");
  }
  commons = newcommons;
}
export default commons;



// WEBPACK FOOTER //
// ./src/public/common.js